export interface Album {
  id: string;
  artistaId: string;
  artistaNome: string;
  titulo: string;
  ano: number;
  imagem: string;
  descricao: string;
  musicas: number;
}

export const albuns: Album[] = [
  // Fernandinho
  {
    id: "galileu",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    titulo: "Galileu",
    ano: 2003,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20abstract%20musical%20worship%20dark%20golden%20accents%20minimalist%20design&width=300&height=300&seq=godoy-album-galileu&orientation=squarish",
    descricao: "Álbum que consagrou Fernandinho como um dos maiores nomes do gospel brasileiro.",
    musicas: 12,
  },
  {
    id: "uma-nova-historia",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    titulo: "Uma Nova História",
    ano: 2015,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20abstract%20new%20beginning%20musical%20dark%20background%20golden%20light&width=300&height=300&seq=godoy-album-nova&orientation=squarish",
    descricao: "Projeto aclamado que trouxe um novo som à adoração brasileira.",
    musicas: 14,
  },
  {
    id: "teus-sonhos",
    artistaId: "fernandinho",
    artistaNome: "Fernandinho",
    titulo: "Teus Sonhos",
    ano: 2008,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20dream%20musical%20abstract%20dark%20golden%20minimalist&width=300&height=300&seq=godoy-album-sonhos&orientation=squarish",
    descricao: "Álbum com canções proféticas e inspiradoras para o povo de Deus.",
    musicas: 11,
  },
  // André Valadão
  {
    id: "classicos",
    artistaId: "andre-valadao",
    artistaNome: "André Valadão",
    titulo: "Clássicos",
    ano: 2010,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20classic%20musical%20worship%20elegant%20dark%20golden%20design&width=300&height=300&seq=godoy-album-classicos&orientation=squarish",
    descricao: "Coletânea dos maiores clássicos do ministério de André Valadão.",
    musicas: 15,
  },
  {
    id: "lider-de-adoracao",
    artistaId: "andre-valadao",
    artistaNome: "André Valadão",
    titulo: "Líder de Adoração",
    ano: 2005,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20worship%20leader%20musical%20abstract%20dark%20golden%20light&width=300&height=300&seq=godoy-album-lider&orientation=squarish",
    descricao: "Álbum que marcou uma geração de adoradores no Brasil.",
    musicas: 13,
  },
  // Ana Paula Valadão
  {
    id: "dt-1",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    titulo: "Diante do Trono",
    ano: 1998,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20worship%20throne%20musical%20abstract%20dark%20golden%20elegant&width=300&height=300&seq=godoy-album-dt1&orientation=squarish",
    descricao: "O álbum que deu origem ao maior movimento de adoração do Brasil.",
    musicas: 14,
  },
  {
    id: "dt-exaltado",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    titulo: "Exaltado",
    ano: 2003,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20exalted%20worship%20musical%20abstract%20dark%20golden%20design&width=300&height=300&seq=godoy-album-exaltado&orientation=squarish",
    descricao: "Um dos álbuns mais aclamados da série Diante do Trono.",
    musicas: 16,
  },
  {
    id: "dt-tua-visao",
    artistaId: "ana-paula-valadao",
    artistaNome: "Ana Paula Valadão",
    titulo: "Tua Visão",
    ano: 2007,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20vision%20musical%20abstract%20dark%20golden%20light&width=300&height=300&seq=godoy-album-visao&orientation=squarish",
    descricao: "Álbum profético que impactou a nação com a visão de Deus.",
    musicas: 14,
  },
  // Aline Barros
  {
    id: "voz-do-milenio",
    artistaId: "aline-barros",
    artistaNome: "Aline Barros",
    titulo: "Voz do Milênio",
    ano: 2000,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20millennium%20musical%20worship%20golden%20dark%20elegant%20design&width=300&height=300&seq=godoy-album-milenio&orientation=squarish",
    descricao: "Álbum que consagrou Aline como uma das maiores vozes do gospel.",
    musicas: 12,
  },
  {
    id: "ressuscita-me",
    artistaId: "aline-barros",
    artistaNome: "Aline Barros",
    titulo: "Ressuscita-me",
    ano: 2008,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20resurrection%20musical%20abstract%20dark%20golden%20light&width=300&height=300&seq=godoy-album-ressuscita&orientation=squarish",
    descricao: "Projeto com canções de fé e restauração que tocaram milhões.",
    musicas: 14,
  },
  // Eli Soares
  {
    id: "casa-de-deus",
    artistaId: "eli-soares",
    artistaNome: "Eli Soares",
    titulo: "Casa de Deus",
    ano: 2017,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20house%20of%20god%20worship%20musical%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-casa&orientation=squarish",
    descricao: "Álbum de adoração com sons contemporâneos e letras profundas.",
    musicas: 11,
  },
  // Gabriela Rocha
  {
    id: "lugar-secreto",
    artistaId: "gabriela-rocha",
    artistaNome: "Gabriela Rocha",
    titulo: "Lugar Secreto",
    ano: 2018,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20secret%20place%20worship%20musical%20abstract%20dark%20golden%20design&width=300&height=300&seq=godoy-album-lugar&orientation=squarish",
    descricao: "Álbum que projetou Gabriela como referência da nova geração gospel.",
    musicas: 10,
  },
  {
    id: "gabriela-rocha-live",
    artistaId: "gabriela-rocha",
    artistaNome: "Gabriela Rocha",
    titulo: "Live Session",
    ano: 2020,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20live%20session%20musical%20performance%20dark%20golden%20stage&width=300&height=300&seq=godoy-album-live&orientation=squarish",
    descricao: "Gravação ao vivo com participações especiais e versões exclusivas.",
    musicas: 12,
  },
  // Ton Carfi
  {
    id: "marca-da-promessa",
    artistaId: "ton-carfi",
    artistaNome: "Ton Carfi",
    titulo: "Marca da Promessa",
    ano: 2006,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20promise%20mark%20worship%20musical%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-promessa&orientation=squarish",
    descricao: "Álbum com canções que marcaram uma geração no movimento gospel.",
    musicas: 13,
  },
  // Kleber Lucas
  {
    id: "deus-cuida",
    artistaId: "kleber-lucas",
    artistaNome: "Kleber Lucas",
    titulo: "Deus Cuida de Mim",
    ano: 2004,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20god%20cares%20worship%20musical%20abstract%20dark%20golden%20design&width=300&height=300&seq=godoy-album-cuida&orientation=squarish",
    descricao: "O álbum que apresentou um dos maiores clássicos do gospel brasileiro.",
    musicas: 12,
  },
  {
    id: "aos-pes-da-cruz",
    artistaId: "kleber-lucas",
    artistaNome: "Kleber Lucas",
    titulo: "Aos Pés da Cruz",
    ano: 2009,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20cross%20worship%20musical%20abstract%20dark%20golden%20light&width=300&height=300&seq=godoy-album-cruz&orientation=squarish",
    descricao: "Álbum de adoração profunda com canções de arrependimento e graça.",
    musicas: 14,
  },
  // Isaías Saad
  {
    id: "caminho",
    artistaId: "isaias-saad",
    artistaNome: "Isaías Saad",
    titulo: "Caminho",
    ano: 2019,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20path%20way%20musical%20abstract%20dark%20golden%20design&width=300&height=300&seq=godoy-album-caminho&orientation=squarish",
    descricao: "Projeto solo com composições autorais de profunda espiritualidade.",
    musicas: 9,
  },
  // Preto no Branco
  {
    id: "pnb-1",
    artistaId: "preto-no-branco",
    artistaNome: "Preto no Branco",
    titulo: "Preto no Branco",
    ano: 2016,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20black%20white%20contrast%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-pnb1&orientation=squarish",
    descricao: "O álbum de estreia do coletivo que revolucionou o gospel brasileiro.",
    musicas: 12,
  },
  // Davi Sacer
  {
    id: "confiar",
    artistaId: "davi-sacer",
    artistaNome: "Davi Sacer",
    titulo: "Confiar",
    ano: 2012,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20trust%20worship%20musical%20abstract%20dark%20golden%20design&width=300&height=300&seq=godoy-album-confiar&orientation=squarish",
    descricao: "Álbum com canções que exaltam a fé e a confiança em Deus.",
    musicas: 11,
  },
  // Lukas Agustinho
  {
    id: "leao",
    artistaId: "lukas-agustinho",
    artistaNome: "Lukas Agustinho",
    titulo: "Leão",
    ano: 2020,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20lion%20strength%20worship%20musical%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-leao&orientation=squarish",
    descricao: "Álbum com sons modernos e letras que glorificam o nome do Senhor.",
    musicas: 10,
  },
  // Anderson Freire
  {
    id: "raridade",
    artistaId: "anderson-freire",
    artistaNome: "Anderson Freire",
    titulo: "Raridade",
    ano: 2013,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20rarity%20treasure%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-raridade&orientation=squarish",
    descricao: "O álbum que apresentou o hit 'Raridade' ao Brasil gospel.",
    musicas: 13,
  },
  {
    id: "acalha",
    artistaId: "anderson-freire",
    artistaNome: "Anderson Freire",
    titulo: "Acalha o Meu Coração",
    ano: 2016,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20calm%20heart%20peace%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-acalha&orientation=squarish",
    descricao: "Projeto com canções que trazem paz e tranquilidade ao coração.",
    musicas: 12,
  },
  // Fernanda Brum
  {
    id: "curado",
    artistaId: "fernanda-brum",
    artistaNome: "Fernanda Brum",
    titulo: "Curado",
    ano: 2011,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20healed%20restored%20worship%20musical%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-curado&orientation=squarish",
    descricao: "Álbum consagrado que trouxe canções de cura e restauração.",
    musicas: 14,
  },
  // Bruna Karla
  {
    id: "sou-humano",
    artistaId: "bruna-karla",
    artistaNome: "Bruna Karla",
    titulo: "Sou Humano",
    ano: 2012,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20human%20vulnerability%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-humano&orientation=squarish",
    descricao: "Álbum que mostra a humanidade e a dependência de Deus.",
    musicas: 12,
  },
  // Nívea Soares
  {
    id: "gloria-e-honra",
    artistaId: "nivea-soares",
    artistaNome: "Nívea Soares",
    titulo: "Glória e Honra",
    ano: 2005,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20glory%20honor%20worship%20musical%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-gloria&orientation=squarish",
    descricao: "Álbum clássico de adoração com canções atemporais.",
    musicas: 13,
  },
  // Rosa de Saron
  {
    id: "depois-do-inverno",
    artistaId: "rosa-de-saron",
    artistaNome: "Rosa de Saron",
    titulo: "Depois do Inverno",
    ano: 2005,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20winter%20after%20seasons%20musical%20rock%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-inverno&orientation=squarish",
    descricao: "Um dos álbuns mais emblemáticos do rock cristão brasileiro.",
    musicas: 12,
  },
  {
    id: "horizonte-distante",
    artistaId: "rosa-de-saron",
    artistaNome: "Rosa de Saron",
    titulo: "Horizonte Distante",
    ano: 2012,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20distant%20horizon%20musical%20rock%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-horizonte&orientation=squarish",
    descricao: "Álbum que mistura rock, mpb e espiritualidade de forma única.",
    musicas: 14,
  },
  // Oficina G3
  {
    id: "humanos",
    artistaId: "oficina-g3",
    artistaNome: "Oficina G3",
    titulo: "Humanos",
    ano: 1998,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20humans%20rock%20musical%20abstract%20dark%20golden%20intense&width=300&height=300&seq=godoy-album-humanos&orientation=squarish",
    descricao: "Álbum de estreia que marcou o início de uma nova era no rock cristão.",
    musicas: 11,
  },
  {
    id: "davids",
    artistaId: "oficina-g3",
    artistaNome: "Oficina G3",
    titulo: "Davids",
    ano: 2007,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20david%20biblical%20rock%20musical%20abstract%20dark%20golden%20warrior&width=300&height=300&seq=godoy-album-davids&orientation=squarish",
    descricao: "Álbum conceitual com sons pesados e letras de fé inabalável.",
    musicas: 13,
  },
  // Cristina Mel
  {
    id: "um-toque",
    artistaId: "cristina-mel",
    artistaNome: "Cristina Mel",
    titulo: "Um Toque",
    ano: 2003,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20touch%20divine%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-toque&orientation=squarish",
    descricao: "Álbum com canções tocantes que marcaram a carreira de Cristina Mel.",
    musicas: 14,
  },
  // Cassiane
  {
    id: "com-muito-louvor",
    artistaId: "cassiane",
    artistaNome: "Cassiane",
    titulo: "Com Muito Louvor",
    ano: 1995,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20worship%20praise%20musical%20abstract%20dark%20golden%20vintage&width=300&height=300&seq=godoy-album-louvor&orientation=squarish",
    descricao: "Clássico atemporal de uma das pioneiras do gospel brasileiro.",
    musicas: 16,
  },
  {
    id: "viva",
    artistaId: "cassiane",
    artistaNome: "Cassiane",
    titulo: "Viva",
    ano: 2010,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20alive%20live%20musical%20worship%20abstract%20dark%20golden&width=300&height=300&seq=godoy-album-viva&orientation=squarish",
    descricao: "Álbum que provou a vigência e a força de Cassiane no gospel contemporâneo.",
    musicas: 14,
  },
  // ===== NOVOS ÁLBUNS =====
  // Kemuel
  {
    id: "kemuel-album",
    artistaId: "kemuel",
    artistaNome: "Kemuel",
    titulo: "Kemuel",
    ano: 2015,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20worship%20contemporary%20gospel%20dark%20golden%20modern%20minimalist&width=300&height=300&seq=godoy-album-kemuel&orientation=squarish",
    descricao: "Álbum de estreia do ministério Kemuel com sons contemporâneos de adoração.",
    musicas: 10,
  },
  // Paulo Cesar Baruk
  {
    id: "baruk-album",
    artistaId: "paulo-cesar-baruk",
    artistaNome: "Paulo Cesar Baruk",
    titulo: "Baruk",
    ano: 2012,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20piano%20worship%20gospel%20dark%20golden%20elegant%20minimalist&width=300&height=300&seq=godoy-album-baruk&orientation=squarish",
    descricao: "Álbum que consagrou Paulo Cesar Baruk como referência na adoração com piano.",
    musicas: 12,
  },
  // Leandro Borges
  {
    id: "identidade",
    artistaId: "leandro-borges",
    artistaNome: "Leandro Borges",
    titulo: "Identidade",
    ano: 2019,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20identity%20self%20worship%20gospel%20dark%20golden%20abstract&width=300&height=300&seq=godoy-album-identidade&orientation=squarish",
    descricao: "Projeto que trouxe canções de identidade e propósito na adoração.",
    musicas: 10,
  },
  // Vinicius Zulato
  {
    id: "filho-prodigo",
    artistaId: "vinicius-zulato",
    artistaNome: "Vinicius Zulato",
    titulo: "Filho Pródigo",
    ano: 2022,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20prodigal%20son%20return%20worship%20gospel%20dark%20golden%20abstract&width=300&height=300&seq=godoy-album-prodigo&orientation=squarish",
    descricao: "Álbum com mensagens de restauração e graça através da adoração.",
    musicas: 10,
  },
  // Anderson Capote
  {
    id: "deixa-arder",
    artistaId: "anderson-capote",
    artistaNome: "Anderson Capote",
    titulo: "Deixa Arder",
    ano: 2021,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20fire%20burn%20worship%20gospel%20dark%20golden%20intense%20abstract&width=300&height=300&seq=godoy-album-arder&orientation=squarish",
    descricao: "Álbum de adoração intensa com sons contemporâneos e letras profundas.",
    musicas: 10,
  },
  // Adhemar de Campos
  {
    id: "consagrado",
    artistaId: "adhemar-de-campos",
    artistaNome: "Adhemar de Campos",
    titulo: "Consagrado",
    ano: 1990,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20consecrated%20worship%20gospel%20vintage%20dark%20golden%20elegant&width=300&height=300&seq=godoy-album-consagrado&orientation=squarish",
    descricao: "Clássico atemporal de Adhemar de Campos com hinos de adoração.",
    musicas: 14,
  },
  // Heloisa Rosa
  {
    id: "heloisa-rosa",
    artistaId: "heloisa-rosa",
    artistaNome: "Heloisa Rosa",
    titulo: "Heloisa Rosa",
    ano: 2019,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20female%20worship%20gospel%20dark%20golden%20soft%20elegant%20abstract&width=300&height=300&seq=godoy-album-heloisa&orientation=squarish",
    descricao: "Álbum de estreia com canções proféticas e adoração profunda.",
    musicas: 10,
  },
  // Comunidade de Nilópolis
  {
    id: "o-deus-que-faz",
    artistaId: "comunidade-de-nilopolis",
    artistaNome: "Comunidade de Nilópolis",
    titulo: "O Deus que Faz",
    ano: 2015,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20community%20choir%20worship%20gospel%20dark%20golden%20grand%20abstract&width=300&height=300&seq=godoy-album-nilopolis&orientation=squarish",
    descricao: "Álbum ao vivo com adoração coletiva e canções de milagres.",
    musicas: 12,
  },
  // Quatro por Um
  {
    id: "quatro-por-um",
    artistaId: "quatro-por-um",
    artistaNome: "Quatro por Um",
    titulo: "Quatro por Um",
    ano: 2003,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20pop%20rock%20worship%20gospel%20dark%20golden%20energetic%20abstract&width=300&height=300&seq=godoy-album-quatro&orientation=squarish",
    descricao: "Álbum de estreia que marcou a era do pop rock cristão no Brasil.",
    musicas: 12,
  },
  // David Quinlan
  {
    id: "eu-e-minha-casa",
    artistaId: "david-quinlan",
    artistaNome: "David Quinlan",
    titulo: "Eu e a Minha Casa",
    ano: 2005,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20family%20home%20worship%20gospel%20dark%20golden%20warm%20abstract&width=300&height=300&seq=godoy-album-quinlan&orientation=squarish",
    descricao: "Álbum com canções de adoração familiar e profunda intimidade com Deus.",
    musicas: 12,
  },
  // Lauriete
  {
    id: "alma-vencedora",
    artistaId: "lauriete",
    artistaNome: "Lauriete",
    titulo: "Alma Vencedora",
    ano: 2002,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20victorious%20soul%20worship%20gospel%20dark%20golden%20powerful%20abstract&width=300&height=300&seq=godoy-album-lauriete&orientation=squarish",
    descricao: "Um dos álbuns mais consagrados de Lauriete com hinos de vitória.",
    musicas: 14,
  },
  // Rebanhão
  {
    id: "vem-me-buscar",
    artistaId: "rebanhao",
    artistaNome: "Rebanhão",
    titulo: "Vem Me Buscar",
    ano: 1998,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20rock%20worship%20gospel%20dark%20golden%20classic%20abstract%20guitar&width=300&height=300&seq=godoy-album-rebanhao&orientation=squarish",
    descricao: "Clássico do rock gospel brasileiro com sons marcantes e letras de fé.",
    musicas: 12,
  },
  // Priscila Alcântara
  {
    id: "eletroacustico",
    artistaId: "priscila-alcantara",
    artistaNome: "Priscila Alcântara",
    titulo: "Eletroacústico",
    ano: 2021,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20acoustic%20youth%20worship%20gospel%20dark%20golden%20modern%20abstract&width=300&height=300&seq=godoy-album-priscila&orientation=squarish",
    descricao: "Projeto acústico com sons modernos e mensagens para a juventude cristã.",
    musicas: 10,
  },
  // Thiago Brado
  {
    id: "serenata",
    artistaId: "thiago-brado",
    artistaNome: "Thiago Brado",
    titulo: "Serenata",
    ano: 2022,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20serenade%20worship%20gospel%20dark%20golden%20romantic%20abstract&width=300&height=300&seq=godoy-album-serenata&orientation=squarish",
    descricao: "Álbum com canções autorais de profunda espiritualidade e adoração.",
    musicas: 10,
  },
  // Renascer Praise
  {
    id: "renascer-20",
    artistaId: "renascer-praise",
    artistaNome: "Renascer Praise",
    titulo: "Renascer Praise 20",
    ano: 2008,
    imagem: "https://readdy.ai/api/search-image?query=Album%20cover%20praise%20celebration%20worship%20gospel%20dark%20golden%20grand%20abstract&width=300&height=300&seq=godoy-album-renascer&orientation=squarish",
    descricao: "Coletânea com os maiores hinos do ministério Renascer Praise.",
    musicas: 16,
  },
];